import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import logoNew from "./images/logo-new.jpg";

const Footer = () => {
  return (
    <Box sx={{
      background: "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",
      color: "#fff",
      py: 8,
      mt: 12,
      boxShadow: "0 -4px 12px rgba(0,0,0,0.1)",
    }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} sx={{ mb: 6 }}>
          {/* Brand Column */}
          <Grid colSpan={{ xs: 12, sm: 6, md: 3 }} sx={{ display: "flex", flexDirection: "column", alignItems: { xs: "center", md: "flex-start" } }}>
            <Box
              component="img"
              src={logoNew}
              alt="Dizaver Aluminum Logo"
              sx={{
                height: 80,
                width: "auto",
                borderRadius: 2,
                boxShadow: "0 4px 16px rgba(218,165,32,0.2)",
                mb: 2,
                transition: "transform 0.3s",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            />
            <Typography sx={{ fontWeight: 700, color: "#FFD700", mb: 1 }}>
              Dizaver Aluminum
            </Typography>
            <Typography sx={{ fontSize: "0.9rem", color: "#b0b0b0", textAlign: { xs: "center", md: "left" } }}>
              Professional roofing, siding, and gutter services in Toronto & GTA.
            </Typography>
          </Grid>

          {/* Services Column */}
          <Grid colSpan={{ xs: 12, sm: 6, md: 2 }}>
            <Typography sx={{ fontWeight: 700, color: "#FFD700", mb: 2 }}>
              Services
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Box component="a" href="/#services" sx={{ fontSize: "0.95rem", color: "#b0b0b0", "&:hover": { color: "#FFD700", transition: "0.2s" }, cursor: "pointer", textDecoration: "none" }}>
                Roof Repairs
              </Box>
              <Box component="a" href="/#services" sx={{ fontSize: "0.95rem", color: "#b0b0b0", "&:hover": { color: "#FFD700", transition: "0.2s" }, cursor: "pointer", textDecoration: "none" }}>
                Gutter Cleaning
              </Box>
              <Box component="a" href="/#services" sx={{ fontSize: "0.95rem", color: "#b0b0b0", "&:hover": { color: "#FFD700", transition: "0.2s" }, cursor: "pointer", textDecoration: "none" }}>
                Siding Installation
              </Box>
              <Box component="a" href="/#services" sx={{ fontSize: "0.95rem", color: "#b0b0b0", "&:hover": { color: "#FFD700", transition: "0.2s" }, cursor: "pointer", textDecoration: "none" }}>
                Custom Flashing
              </Box>
            </Box>
          </Grid>

          {/* Quick Links Column */}
          <Grid colSpan={{ xs: 12, sm: 6, md: 2 }}>
            <Typography sx={{ fontWeight: 700, color: "#FFD700", mb: 2 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Box component="a" href="/" sx={{ fontSize: "0.95rem", color: "#b0b0b0", "&:hover": { color: "#FFD700", transition: "0.2s" }, cursor: "pointer", textDecoration: "none" }}>
                Home
              </Box>
              <Box component="a" href="/gallery" sx={{ fontSize: "0.95rem", color: "#b0b0b0", "&:hover": { color: "#FFD700", transition: "0.2s" }, cursor: "pointer", textDecoration: "none" }}>
                Gallery
              </Box>
              <Box component="a" href="/#about" sx={{ fontSize: "0.95rem", color: "#b0b0b0", "&:hover": { color: "#FFD700", transition: "0.2s" }, cursor: "pointer", textDecoration: "none" }}>
                About Us
              </Box>
            </Box>
          </Grid>

          {/* Contact Column */}
          <Grid colSpan={{ xs: 12, sm: 6, md: 3 }}>
            <Typography sx={{ fontWeight: 700, color: "#FFD700", mb: 2 }}>
              Get In Touch
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              <Box>
                <Typography sx={{ fontSize: "0.9rem", color: "#b0b0b0" }}>
                  Phone
                </Typography>
                <Typography sx={{ fontSize: "1rem", color: "#fff", fontWeight: 600 }}>
                  (437) 855-7047
                </Typography>
              </Box>
              <Box>
                <Typography sx={{ fontSize: "0.9rem", color: "#b0b0b0" }}>
                  Address
                </Typography>
                <Typography sx={{ fontSize: "0.95rem", color: "#fff" }}>
                  63 Westmount Ave.
                  <br />
                  Toronto, ON M6H 3K2
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Social Media and Copyright */}
        <Box sx={{ borderTop: "1px solid #444", pt: 4 }}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid colSpan={{ xs: 12, md: 6 }} sx={{ textAlign: { xs: "center", md: "left" }, mb: { xs: 3, md: 0 } }}>
              <Typography sx={{ fontSize: "0.95rem", color: "#b0b0b0" }}>
                &copy; {new Date().getFullYear()} Dizaver Aluminum. All rights reserved.
              </Typography>
              <Typography sx={{ fontSize: "0.85rem", color: "#666", mt: 1 }}>
                Licensed & Insured | Toronto & GTA Service Area
              </Typography>
            </Grid>
            <Grid colSpan={{ xs: 12, md: 6 }} sx={{ display: "flex", justifyContent: { xs: "center", md: "flex-end" }, gap: 2 }}>
              <IconButton
                href="https://www.facebook.com/profile.php?id=61577040364013"
                target="_blank"
                rel="noopener"
                sx={{
                  color: "#fff",
                  "&:hover": { color: "#FFD700" },
                }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                href="https://www.instagram.com/diza_ver/"
                target="_blank"
                rel="noopener"
                sx={{
                  color: "#fff",
                  "&:hover": { color: "#FFD700" },
                }}
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                href="https://www.youtube.com/@DizaverAluminum"
                target="_blank"
                rel="noopener"
                sx={{
                  color: "#fff",
                  "&:hover": { color: "#FFD700" },
                }}
              >
                <YouTubeIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
